/* RESPONSIBLE TEAM: team-reporting */

import type {
  ChartDataResponse,
  GroupedData,
  VisualizationType,
} from '@/features/reporting-charts/types';
import { isDimensionCell, isDualQueryCell } from '@/features/reporting-charts/types';

function isAllMetricValuesZero(data: GroupedData): boolean {
  return data.every((row) =>
    row.every((cell) => {
      if (isDimensionCell(cell)) return true;
      if (isDualQueryCell(cell)) return cell.value === 0;
      return cell === 0 || cell === null;
    }),
  );
}

export function isChartDataEmpty(
  data: ChartDataResponse,
  visualizationType: VisualizationType,
): boolean {
  if (data.length === 0) return true;

  const currentPeriod = data.find((d) => d.period === 'current');
  if (!currentPeriod) return true;

  const innerData = currentPeriod.data;

  switch (visualizationType) {
    case 'counter':
      return false; // for counter chart we don't show empty state
    case 'bar':
    case 'horizontal-bar':
    case 'line':
    case 'area':
    case 'column-line':
    case 'heatmap':
      return innerData.length === 0 || isAllMetricValuesZero(innerData as GroupedData);
    case 'tabular':
    case 'donut':
    default:
      return innerData.length === 0;
  }
}
